<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title> {{ $t('taxPayerSystem') }} </v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('back') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-container>
        <v-row>
          <v-col
            cols="12"
            md="4"
          >
            <v-radio-group
              v-model="sendingType"
              class="mt-0"
              row
              dense
            >
              <v-radio
                v-if="$brand === 'abriron'"
                :label="$t('pna')"
                value="pna"
              />
<!--              <v-radio-->
<!--                :label="$t('directSend')"-->
<!--                value="self"-->
<!--              />-->
              <v-radio
                v-if="$brand === 'abriron'"
                :label="$t('tiss')"
                value="tiss"
              />
              <v-radio
                :label="$t('maher')"
                value="maher"
              />
              <!-- <v-radio
                v-if="$brand === 'abriron'"
                :label="$t('evtsp')"
                value="evtsp"
              /> -->
            </v-radio-group>
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-radio-group
              v-model="taxPayerType"
              class="mt-0"
              row
              dense
            >
              <v-radio
                :label="$t('legal')"
                value="Legal"
              />
              <v-radio
                :label="$t('Individual')"
                value="Individual"
              />
            </v-radio-group>
          </v-col>
          <v-col md="3">
            <v-checkbox
              v-model="autoSending"
              class="mt-0"
              :label="$t('sendAutoToTax')"
              value="active"
            />
          </v-col>
        </v-row>
        <v-row
          style="margin-bottom: 100px"
        >
          <v-col
            v-if="sendingType === 'evtsp'"
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="taxPayerUsername"
              :label="$t('username')"
              outlined
              clearable
              dense
            />
          </v-col>
          <v-col
            v-if="sendingType === 'evtsp'"
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="taxPayerPassword"
              :label="$t('password')"
              outlined
              clearable
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="nationalCode"
              :label="$t('national-code')"
              outlined
              clearable
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="financialCode"
              :label="$t('financial-code')"
              outlined
              clearable
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="uniqueIdTaxPayer"
              :label="$t('uniqueIdTaxPayer')"
              outlined
              clearable
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="state"
              :label="$t('state')"
              outlined
              clearable
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="city"
              :label="$t('city')"
              outlined
              clearable
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="address"
              :label="$t('address')"
              outlined
              clearable
              dense
            />
          </v-col>
<!--          <v-col-->
<!--            cols="12"-->
<!--            md="4"-->
<!--          >-->
<!--            <v-text-field-->
<!--              v-model="webServiceAddressTaxPayer"-->
<!--              :label="$t('webServiceAddressTaxPayer')"-->
<!--              outlined-->
<!--              clearable-->
<!--              dense-->
<!--            />-->
<!--          </v-col>-->
          <v-col
            v-show="sendingType !== 'evtsp'"
            cols="12"
            md="6"
          >
            <v-textarea
              v-model="privateKeyTaxPayer"
              :label="$t('privateKeyTaxPayer')"
              outlined
              clearable
              dense
            />
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              color="primary"
              class="mr-0"
              :loading="loading"
              @click="create"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import General from '../../../../Mixins/general'
export default {
  name: 'Customer',
  components: {
  },
  mixins: [General],
  data: () => ({
    sendingType: 'self',
    taxPayerType: 'legal',
    taxPayerUsername: null,
    taxPayerPassword: null,
    city: null,
    address: null,
    state: null,
    autoSending: null,
    valid: true,
    loading: false,
    render: true,
    nationalCode: null,
    financialCode: null,
    privateKeyTaxPayer: null,
    uniqueIdTaxPayer: null,
    statusTaxPayer: null,
    webServiceAddressTaxPayer: null
  }),
  watch: {
  },
  activated () {
    this.show()
  },
  beforeMount () {
  },
  mounted () {
    this.show()
  },
  methods: {
    create () {
      if (!this.$refs.form.validate()) return false
      var app = this
      app.loading = true
      app.$axios.post(this.$apipoint + 'v2/tax-payer/register', this.$data)
        .then(res => {
          app.snakbarText = app.$t('registered')
          app.snakbarColor = 'green'
          app.snakbar = true
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    show () {
      var app = this
      app.loading = true
      app.$axios.get(this.$endpoint + 'taxPayer', {
        params: {
        }
      })
        .then(res => {
          app.$nextTick(() => {
            res = res.data
            app.taxPayerUsername = res.taxPayerUsername
            app.taxPayerPassword = res.taxPayerPassword
            app.autoSending = res.auto_sending
            app.sendingType = res.sending_type
            app.nationalCode = res.nationalCode
            app.address = res.address
            app.state = res.state
            app.taxPayerType = res.taxPayerType
            app.city = res.city
            app.financialCode = res.financialCode
            app.uniqueIdTaxPayer = res.uniqueIdTaxPayer
            app.webServiceAddressTaxPayer = res.webServiceAddressTaxPayer
            app.privateKeyTaxPayer = res.privateKeyTaxPayer
            app.statusTaxPayer = res.status
            app.render = true
          })
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(() => (app.loading = false))
    }
  }
}
</script>

<style scoped>
.col{
  height: 55px !important;
}
</style>
